import ErrorMapper from '@/bundles/Http/mappers/ErrorMapper';
import { http } from '@/bundles/Http/factory/HttpFactory';
import WeeklyChallengeService from '@/bundles/ActivityGroup/services/WeeklyChallengeService';

function weeklyChallengeServiceFactory() {
  return new WeeklyChallengeService({
    errorMapper: new ErrorMapper(),
    transport: http,
  });
}

export const weeklyChallengeService = weeklyChallengeServiceFactory();
